import { object } from "yup";
export const a9Part1DataSchema = object({});
export const exampleA9Data = [
    {
        data: {},
    },
];
//# sourceMappingURL=a9.js.map